(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Subscription', Subscription);

    Subscription.$inject = ['$resource', 'DateUtils'];

    function Subscription ($resource, DateUtils) {
        var resourceUrl =  'api/subscriptions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start_date = DateUtils.convertLocalDateFromServer(data.start_date);
                        data.end_date = DateUtils.convertLocalDateFromServer(data.end_date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.start_date = DateUtils.convertLocalDateToServer(data.start_date);
                    data.end_date = DateUtils.convertLocalDateToServer(data.end_date);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.start_date = DateUtils.convertLocalDateToServer(data.start_date);
                    data.end_date = DateUtils.convertLocalDateToServer(data.end_date);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
